import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useTypedOpenApi } from '../../providers';
import { publicChecklistsQueryOptions } from './publicChecklistQueries';
import type { PublicChecklistsQueryParams } from './types';

/**
 * One page of the public library, addressed by page number.
 *
 * The dashboard's shape: the paginator drives `page`/`pageSize` and the previous page stays on
 * screen while the next one loads.
 */
export const usePublicChecklistsQuery = (params: PublicChecklistsQueryParams, enabled = true) => {
  const { apiClient } = useTypedOpenApi();

  return useQuery({ ...publicChecklistsQueryOptions(apiClient, params), enabled });
};

/**
 * The same page, suspending.
 *
 * What the dashboard's list uses, so the public tab shows the same page-shaped skeleton its
 * neighbour does instead of a spinner over a blank panel. `placeholderData` is dropped rather than
 * passed through: `useSuspenseQuery` has no use for it — there is no pending render to fill — and
 * its options type does not accept it.
 */
export const useSuspensePublicChecklistsQuery = (params: PublicChecklistsQueryParams) => {
  const { apiClient } = useTypedOpenApi();
  const { placeholderData: _placeholderData, ...options } = publicChecklistsQueryOptions(apiClient, params);

  return useSuspenseQuery(options);
};
